<template>
  <div>
    <div
        v-if="detail_loader"
        style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;background-color:rgba(255,255,255,0.31)"
    >
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row class="table_opacity_8">
        <v-flex xs12 sm12 md12 lg8>
          <v-card>
            <v-layout row>
              <v-flex xs12 md12 lg12>
                <v-card class="pa-2">
                  <!--                <v-card-title class="pl-0">-->
                  <!--&lt;!&ndash;                  <h3 class="heading"> </h3>&ndash;&gt;-->
                  <!--                </v-card-title>-->
                  <v-card-text style="font-size:17px" class="pb-0">
                    <v-layout row wrap>
                      <v-flex xs12 md12 lg12 style="display: flex;">
                        <v-flex xs12 md12 lg6><label><strong>User Name: </strong></label></v-flex>
                        <v-flex xs12 md12 lg6>{{ feedback_detail.first_name }}</v-flex>
                      </v-flex>
                      <v-flex xs12 md12 lg12 style="display: flex;">
                        <v-flex xs12 md12 lg6><label><strong>Email ID: </strong></label></v-flex>
                        <v-flex xs12 md12 lg6>{{ feedback_detail.email_id }}</v-flex>
                      </v-flex>

                      <v-flex xs12 md12 lg12 style="display: flex;">
                        <v-flex xs12 md12 lg6><label><strong>Criticality: </strong></label></v-flex>
                        <v-flex xs12 md12 lg6>{{ feedback_detail.criticality }}</v-flex>
                      </v-flex>

                      <v-flex xs12 md12 lg12 style="display: flex;">
                        <v-flex xs12 md12 lg6><label><strong>Feedback:</strong> </label></v-flex>
                        <v-flex xs12 md12 lg6>{{ feedback_detail.feedback }}</v-flex>
                      </v-flex>

                      <v-flex xs12 md12 lg12 style="display: flex;">
                        <v-flex xs12 md12 lg6><label><strong>Criticality: </strong></label></v-flex>
                        <v-flex xs12 md12 lg6>{{ feedback_detail.criticality }}</v-flex>
                      </v-flex>

                      <v-flex xs12 md12 lg12 style="display: flex;">
                        <v-flex xs12 md12 lg6><label><strong>Additional Information:</strong></label></v-flex>
                        <v-flex xs12 md12 lg6 style="overflow-wrap: break-word;"><span>{{
                            feedback_detail.additional_info
                          }} </span></v-flex>
                      </v-flex>

                      <v-flex xs12 md12 lg12 style="display: flex;">
                        <v-flex xs12 md12 lg6><label><strong>Device Information:</strong> </label></v-flex>
                        <v-flex xs12 md12 lg6 style="overflow-wrap: break-word;"><span>{{
                            feedback_detail.device_info
                          }} </span></v-flex>
                      </v-flex>

                      <v-flex xs12 md12 lg12 style="display: flex;">
                        <v-flex xs12 md12 lg6><label><strong>Issue Module:</strong> </label></v-flex>
                        <v-flex xs12 md12 lg6>{{ feedback_detail.issue_module }}</v-flex>
                      </v-flex>

                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>


        <v-flex xs12 sm12 md12 lg6>
          <v-toolbar
              color="primary"
              dark>
            <v-toolbar-title>{{ "Reply to "}} {{feedback_detail.first_name}}</v-toolbar-title>
            <v-spacer></v-spacer>

          </v-toolbar>

          <v-card>
            <v-container
                fluid
                grid-list-lg class="pa-0">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-card class="black--text">
                    <v-layout class="scroll-y scroll-x" id="scroll1" style="height: 350px">
                      <v-flex xs12 lg12 md12>
                        <v-card-text primary-title>
                          <v-layout row wrap>
                            <v-flex xs12 md12 lg12>
                                <v-form
                                    ref="form"
                                    v-model="form"
                                >
                                <v-textarea
                                    counter box solo
                                    label="Message"
                                    :rules="rules"
                                    auto-grow
                                    rows="7"
                                    v-model="reply_message"
                                ></v-textarea>
                                </v-form>
                            </v-flex>
                          </v-layout>
                        </v-card-text>

                        <v-divider></v-divider>
                        <v-card-actions >
<!--                          <v-btn-->
<!--                              flat-->
<!--                              @click="$refs.form.reset()"-->
<!--                          >-->
<!--                            Clear-->
<!--                          </v-btn>-->
                          <v-spacer></v-spacer>
                          <v-spacer></v-spacer>

                          <v-btn
                              :disabled="reply_message == ''"
                              :loading="isLoading"
                              class="white--text"
                              color="primary"
                              depressed
                              @click="sendReplyMessage()"
                          >Submit</v-btn>
                        </v-card-actions>
                      </v-flex>

                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
      <!-- Delete Resource dialog box -->
      <v-snackbar v-model="snackbar.display" :color="snackbar.color" :top="snackbar.top" :bottom="snackbar.bottom"
                  :left="snackbar.left" :right="snackbar.right" :timeout="snackbar.timeout">
        {{ snackbar.message }}
        <v-btn
            text
            dark
            @click="snackbar.display = false"
        >
          <v-icon
              right
              color="white"
          >
            close
          </v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Detail",

  data: () => {
    return {
      feedback_detail: {},
      detail_loader: false,
      snackbar: {
        message: '',
        display: false,
        color: 'black',
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000
      },
      reply_message: '',
      form: false,
      isLoading: false,
      rules: [reply_message => (reply_message || '' ).length <= 3500 || 'Max 3500 characters']
    };
  },

  methods: {
    getNotificationDetail: function () {
      this.detail_loader = true;

      axios
          .get(
              `${process.env.VUE_APP_API_URL}/api/v1/feedback-details/` +
              this.$route.params.id,
              {headers: this.$headers}
          )
          .then((response) => {
            if (response.data.status == 1) {
              // console.log(response.data.feedback)
              this.feedback_detail = response.data.feedback;
              this.detail_loader = false;
            }
          })
          .catch((error) => {
            // console.log(error);
          });
    },
    sendReplyMessage(){
      let formData = new FormData;
      formData.append("feedback_id", this.feedback_detail.id);
      formData.append("first_name", this.feedback_detail.first_name);
      formData.append("last_name", this.feedback_detail.last_name);
      formData.append("email" ,this.feedback_detail.email_id);
      formData.append("message", this.reply_message);

      this.isLoading =true;
      axios
          .post(
              `${process.env.VUE_APP_API_URL}/api/v1/store-reply-feedback-message`,formData,{headers:
                this.$headers}
          ).then((response) => {
            if(response.data.status == 1){
              this.isLoading = false;
              this.snackbar.display = true;
              this.snackbar.message = response.data.message;
              // this.$refs.form.reset();
              this.$router.push({ name: 'feedbackList', params:{ message: response.data.message}})
              // this.$router.push({
              //   path: '/feedbackList',
              //   query: { message: response.data.message }
              // });

            }else if(response.data.status == 0){
              this.isLoading = false;
              this.snackbar.display = true;
              this.snackbar.message = response.data.message;
            }
      }).catch((error) => {
        this.$refs.form.reset();
        this.isLoading = false;
        this.snackbar.display = true;
        this.snackbar.message = "Something went wrong";
      });
    }
  },
  mounted() {
    this.getNotificationDetail();

  },
};
</script>


